import { render } from "./Assortitotaal.vue?vue&type=template&id=39999d3b&scoped=true"
import script from "./Assortitotaal.vue?vue&type=script&lang=js"
export * from "./Assortitotaal.vue?vue&type=script&lang=js"

import "./Assortitotaal.vue?vue&type=style&index=0&id=39999d3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39999d3b"]])

export default __exports__